import type { IconSvgObject } from './types';

const MessageCircleDashedIcon: IconSvgObject = [
  ["path", { d: "M7.47017 20.3687C5.60194 19.362 4.34478 20.2979 3.23609 20.4658C3.0679 20.4913 2.90041 20.4302 2.78013 20.31C2.59757 20.1274 2.56283 19.8451 2.66367 19.6074C3.09882 18.5818 3.49837 16.6382 2.95357 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.52209 11C3.02179 6.22333 7.06112 2.5 11.9701 2.5C17.2168 2.5 21.4701 6.75329 21.4701 12C21.4701 17.2467 17.2168 21.5 11.9701 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MessageCircleDashedIcon;
